import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ButtonWrapper } from 'components/ButtonWrapper';

const DeactivateBtn = styled(ButtonWrapper)`
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 8px 16px;
	gap: 10px;
	position: absolute;
	width: 135.5px;
	height: 40px;
	right: 0;
	top: 0;
	border: 1px solid #ff3b30;
	border-radius: 4px;
	background: #fff;
	font-family: 'Inter', sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	color: #ff3b30;
	cursor: pointer;
	z-index: 10;
`;

export default function DeactivateButton({ onDeactivate }) {
	return <DeactivateBtn onClick={onDeactivate}>Deactivate</DeactivateBtn>;
}

DeactivateButton.propTypes = {
	onDeactivate: PropTypes.func.isRequired,
};
